import LogCannon from '@ace-clublabs/log-cannon';
import axios from 'axios';
import CookieHelper from '../../utils/cookieHelper';
import { SubmitAdyenToken, ISubmitAdyenTokenRequest } from '../contracts';
import { createAxiosConfig } from '../mockHelper';

export const SubmitAdyenTokenApi = (endpoint: string): SubmitAdyenToken => {
  let logInfo: any = { endpoint };
  return async (sessionId: string, payload: ISubmitAdyenTokenRequest) => {
    try {
      LogCannon.blast('SubmitAdyenTokenApi start', logInfo);
      const scenario = CookieHelper.getCookie('scenario');
      const config = createAxiosConfig(scenario, endpoint);

      config.headers = {
        ...config.headers,
        'Client-Token': sessionId,
      };

      const { data } = await axios.post(endpoint, payload, config);

      logInfo = { ...logInfo, data };
      LogCannon.blast('SubmitAdyenTokenApi success', logInfo);

      return Promise.resolve(data);
    } catch (error: any) {
      const message = (error?.response?.data?.error?.message || error?.response?.data?.error?.code) ?? 'An exception';
      logInfo = { ...logInfo, message };
      LogCannon.blast('SubmitAdyenTokenApi failure', logInfo);
      return Promise.reject({ message });
    }
  };
};
